var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerfilAlunoNaoSelecionado({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 28.5C26.5 26.9087 25.8679 25.3826 24.7426 24.2574C23.6174 23.1321 22.0913 22.5 20.5 22.5C18.9087 22.5 17.3826 23.1321 16.2574 24.2574C15.1321 25.3826 14.5 26.9087 14.5 28.5",
    stroke: "#8E58BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 22.5C22.7091 22.5 24.5 20.7091 24.5 18.5C24.5 16.2909 22.7091 14.5 20.5 14.5C18.2909 14.5 16.5 16.2909 16.5 18.5C16.5 20.7091 18.2909 22.5 20.5 22.5Z",
    stroke: "#8E58BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 30.5C26.0228 30.5 30.5 26.0228 30.5 20.5C30.5 14.9772 26.0228 10.5 20.5 10.5C14.9772 10.5 10.5 14.9772 10.5 20.5C10.5 26.0228 14.9772 30.5 20.5 30.5Z",
    stroke: "#8E58BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerfilAlunoNaoSelecionado);
export default __webpack_public_path__ + "static/media/iconPerfilAlunoNaoSelecionado.ee35cce9641175fb3fb4e7ca32c6ef4f.svg";
export { ForwardRef as ReactComponent };